export default [
    {
        path: 'task-groups',
        name: 'activity-log.task-groups',
        component: () => import(/* webpackChunkName: "task-groups-module" */ './index.vue'),
        children: [
            {
                path: 'new',
                name: 'activity-log.task-groups.new',
                component: () =>
                    import(/* webpackChunkName: "task-groups-module" */ '@views/TaskGroups/TaskGroupPanel/index'),
            },
            {
                path: ':id',
                name: 'activity-log.task-groups.group',
                component: () =>
                    import(/* webpackChunkName: "task-groups-module" */ '@views/TaskGroups/TaskGroupPanel/index'),
            },
        ],
    },
];
